<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img src="../../assets/logoKLA.png" width="230px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center style="text-align: center">
                    <v-flex xs12 sm12 lg12>
                      <p v-if="!inscricaoNaoEncontrada" style="margin-bottom: 0px;">Informe seu CPF:</p>
                      <p v-if="inscricaoNaoEncontrada" style="margin-bottom: 0px;">Informe também seu e-mail para continuar:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg5>
                      <v-text-field class="cpf" :value="cpf" light label="CPF" color="#00695C" outlined maxlength="11" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="cpf"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg5 v-if="inscricaoNaoEncontrada">
                      <v-text-field class="cpf" light label="EMAIL" color="#00695C" outlined hide-details dense required v-model="email"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-btn v-if="!inscricaoNaoEncontrada" dark block @click="localizarInscricao">CHECK-IN</v-btn>
                      <v-btn v-if="inscricaoNaoEncontrada" dark block @click="inscreverComEmail">CHECK-IN</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                    </v-flex>
                    <NumericKeyboard v-if="!inscricaoNaoEncontrada" @onChange="onChangeCPF" :input="cpf" />
                    <CompleteKeyboard v-if="inscricaoNaoEncontrada" @onChange="onChangeEmail" :input="email" />
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logo.webp" width="130px">
          </a>
        </div>

        <v-dialog v-model="exibeEtiqueta" max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">{{msgResultado}}</span>
            </v-card-title>
            <v-card-text style="text-align: center;padding:0 24px 0;">
              <v-container id="printEtiqueta">
                <v-row align="center" justify="center" style="margin-top: 10px">
                  <v-col cols="4" sm="4" md="4" style="padding: 18px; padding-top: 17px">
                    <qrcode-vue render-as="svg" :value="inscricao.cod_incricao" :size="100" level="H"></qrcode-vue>
                  </v-col>
                  <v-col cols="8" sm="8" md="8" style="padding-left: 10px; margin-top: 15px">
                    <p class="texto" style="text-align: left;"><b>{{inscricao.nomeCracha.toUpperCase()}}</b></p>
                    <p class="texto" style="text-align: left; margin-top: 5px;">{{inscricao.cargo.toUpperCase()}}</p>
                    <p class="texto" style="text-align: left; margin-top: 5px;"><b>{{inscricao.empresa.toUpperCase()}}</b></p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="margin-top: -22px; text-align: center">
                    <!-- <img src="../../assets/logoAIPassIntelite-preto.png" width="130px" height="20px"> -->
                    <p style="color: #000; font-size: 12px"><b>@intelite_tecnologia</b></p>
                  </v-col>
                </v-row>
              </v-container>
              <p style="font-size: 15px; color: orange">Confira os dados antes de imprimir</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="imprimir">IMPRIMIR ETIQUETA</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import CpfValidate from '../../componentes/validators/rules/cpf'
  import QrcodeVue from 'qrcode.vue'
  import { baseApiUrl } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import { mapState } from 'vuex'
  // import moment from 'moment'
  import axios from 'axios'
  import PH from 'print-html-element'
  import NumericKeyboard from '../../componentes/NumericKeyboard'
  import CompleteKeyboard from '../../componentes/CompleteKeyboard'
  import 'simple-keyboard/build/css/index.css'
  export default {
    components: {
      Snackbar,
      QrcodeVue,
      Loading,
      NumericKeyboard,
      CompleteKeyboard
    },
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),
    data: function () {
      return {
        mask: "###.###.###-##",
        user: {},
        cpf: '',
        email: '',
        dialogCancelamento: false,
        exibeEtiqueta: false,
        qtdInscritos: 0,
        capacidadeEvento: 0,
        reserva: 0,
        sexo: ['MASCULINO', 'FEMININO'],
        tipo: ['MEMBRO', 'VISITANTE'],
        doses: [
          { value: '1Dose', text: "TOMEI A 1ª DOSE" },
          { value: '2Dose', text: "TOMEI A 2ª DOSE" },
          { value: '3Dose', text: "TOMEI A 3ª DOSE" },
          { value: '0Dose', text: "NÃO ME VACINEI" },
          { value: 'naoInformado', text: "PREFIRO NÃO INFORMAR" },
        ],
        inscricao: {
          cod_incricao: '',
          nome: '',
          nomeCracha: '',
          cpf: '',
          eventoId: '',
          email: '',
          empresa: '',
          cargo: '',
          statusPagamento: 'PAGO',
          id: ''
        },
        eventos: [],
        isLoading: false,
        fullPage: true,
        jaExiste: false,
        codigoExistente: '',
        msgResultado: '',
        idInscricao: '',
        inscricaoNaoEncontrada: false,
      }
    },

    mounted: function () {
      this.$validator.localize('pt', this.dictionary)
    },

    methods: {
      onChangeCPF(input) {
        if (input.length <= 11) {
          this.cpf = input
        }
      },

      onChangeEmail(input) {
        this.email = input
      },

      imprimir() {
        this.isLoading = true
        PH.printElement(document.getElementById('printEtiqueta'))
        setTimeout(() => {
          this.isLoading = false
          window.location.reload();
        }, 4000);
      },

      async localizarInscricao() {
        var vm = this;
        if (this.cpf == '' || !CpfValidate(this.cpf)) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha seu CPF e tente novamente!", "ATENÇÃO")
        } else {
          try {
            this.isLoading = true
            await axios.get(`${baseApiUrl}inscricoes?filter={"where":{"cpf":"${this.setMaskCpf(this.cpf)}"}}`).then(response => {
              if (response.data) {
                this.inscricao.cod_incricao = response.data[0].cod_incricao
                this.inscricao.nomeCracha = response.data[0].nomeCracha.toUpperCase()
                this.inscricao.empresa = response.data[0].empresa.toUpperCase()
                this.inscricao.cargo = response.data[0].cargo.toUpperCase()
                this.exibeEtiqueta = true
                this.isLoading = false
              }
            })
          } catch (error) {
            this.isLoading = false
            this.inscricaoNaoEncontrada = true
          }
        }
      },

      setMaskCpf(cpf) {
        if (cpf) {
          cpf = cpf.replace(/\D/g,"");
          cpf = cpf.replace(/(\d{3})(\d)/,"$1.$2");
          cpf = cpf.replace(/(\d{3})(\d)/,"$1.$2");
          cpf = cpf.replace(/(\d{3})(\d{1,2})$/,"$1-$2");
        }

        return cpf;
      },

      async inscreverComEmail() {
        var vm = this
        if (this.cpf == '' || this.email == '' || !CpfValidate(this.cpf)) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha seu CPF e tente novamente!", "ATENÇÃO")
        } else {
          try {
            this.isLoading = true
            this.email = this.email.replaceAll(/\s/g,'').toLowerCase()
            await axios.get(`${baseApiUrl}inscricoes?filter={"where":{"and":[{"email":"${this.email}"},{"eventoId":"620bb70295397f64f6643331"},{"statusPagamento":{"inq":["PAGO","PENDENTE"]}}]}}`).then(response => {
              if (response.data) {
                this.inscricao.nome = response.data[0].nome
                this.inscricao.nomeCracha = response.data[0].nomeCracha
                this.inscricao.cpf = this.setMaskCpf(this.cpf)
                this.inscricao.eventoId = response.data[0].eventoId
                this.inscricao.email = response.data[0].email
                this.inscricao.empresa = response.data[0].empresa
                this.inscricao.cargo = response.data[0].cargo
                this.inscricao.id = response.data[0].id
                this.inscricao.cod_incricao = new Date().getTime().toString().substr(8, 12)
                this.confirmarInscricao()
              }
            })
          } catch (error) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#F9A825", "Pré-inscrição não localizada", "DESCULPE")
            this.inscricaoNaoEncontrada = false
            this.email = ''
            this.cpf = ''
          }
        }
      },

      async confirmarInscricao() {
        try {
          await axios.post(`${baseApiUrl}inscricoes/replaceOrCreate`, this.inscricao)
          .then(() => {
            this.isLoading = false
            this.exibeEtiqueta = true
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar cadastro, tente novamente", "ERRO")
          })
        } catch (error) {
          //
        }
      },

      formatDate(date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null
        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateBrz(date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHora(date) {
        if (!date) return null
        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      async realizarInscricao() {
        await this.carregaDados()
        this.isLoading = true
        this.jaExiste = false
        if (this.inscricao.eventoId == '' || this.inscricao.cpf == '' || this.inscricao.email == '' || this.inscricao.infoVacina == '' || !CpfValidate(this.inscricao.cpf)) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
        } else {
          for (var key in this.eventos) {
            if (this.eventos.hasOwnProperty(key)) {
              if (this.eventos[key].id == this.inscricao.eventoId) {
                this.capacidadeEvento = this.eventos[key].vagas
                this.eventoSelecionado = this.eventos[key].nome
                this.reserva = this.eventos[key].reserva
              }
            }
          }

          await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.inscricao.eventoId}`).then(res => {
            this.qtdInscritos = res.data.length + this.reserva
            if (res.data.length > 0) {
              for (var j = 0; j <= res.data.length - 1; j++) {
                if (res.data[j].cpf == this.inscricao.cpf) {
                  this.jaExiste = true
                  this.insricaoExistente = res.data[j]
                  this.codigoExistente = res.data[j].cod_incricao
                }
              }
            }
          })

          if (this.jaExiste) {
            this.msgResultado = 'Já existe um cadastro realizado para esse evento com o CPF informado'
            this.isLoading = false
            this.inscricao.cod_incricao = this.codigoExistente
            this.dialog = true
          } else if (this.qtdInscritos == this.capacidadeEvento && !this.jaExiste) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, a capacidade máxima para o evento selecionado foi atingida!", "INFORMAÇÃO")
          } else {
            this.inscricao.cod_incricao = new Date().getTime().toString().substr(8, 12)
            this.inscricao.statusPagamento = 'PAGO'
            await axios.post(`${baseApiUrl}Inscricoes/replaceOrCreate`, this.inscricao)
            .then(() => {
              this.isLoading = false
              this.msgResultado = 'Inscrição confirmada com sucesso!'
              this.dialog = true
              this.carregaDados()

            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar cadastro, tente novamente", "ERRO")
            })
          }
        }
      },

      compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const dataA = a.fim;
        const dataB = b.fim;

        let comparison = 0;
        if (dataA > dataB) {
          comparison = 1;
        } else if (dataA < dataB) {
          comparison = -1;
        }
        return comparison;
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #142c52, #92c1e1);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #000000;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }
</style>
